import React from 'react';
import { useSelector } from 'react-redux';

import styled from 'styled-components';

import { Row } from 'apps/auth/components/common/Layout/Row';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import type { PopupNewHandle } from 'apps/auth/components/common/Popup/PopupNew';
import type { RootState } from 'apps/auth/redux/store';

const Image = styled.img`
    max-width: 100%;
`;

interface OwnProps {
    popupRef: React.RefObject<PopupNewHandle>;
    file?: File | null;
    imageUrl?: string | null;
    uploadFile: (event: React.MouseEvent<HTMLElement>) => void;
}

type FileUploadPopupProps = OwnProps;
type MessagesSlice = {
    jsMessages?: Record<string, string>;
};

const FileUploadPopup: React.FC<FileUploadPopupProps> = (props) => {
    const send = useSelector((state: RootState) => (state.messages as MessagesSlice | undefined)?.jsMessages?.['chat.js.message.upload.send']);
    const cancel = useSelector((state: RootState) => (state.messages as MessagesSlice | undefined)?.jsMessages?.['chat.js.message.upload.cancel']);

    return (
        <ComplexPopup
            popupRef={props.popupRef}
            primaryButtonText={send}
            onPrimaryButtonClick={props.uploadFile}
            secondaryButtonText={cancel}
            onSecondaryButtonClick={() => props.popupRef.current?.close()}
        >
            <Row flex justify="center">
                {props.imageUrl && <Image src={props.imageUrl} alt={props.file?.name ?? 'file preview'} />}
            </Row>
        </ComplexPopup>
    );
};

export default FileUploadPopup;
